<template>
  <div>
    <!-- Field TEXT -->
    <b-field
      v-if="typeField === 'text'"
      :label="label"
      :message="message"
      :type="statusType"
    >
      <b-input
        v-model="localValue"
        v-bind="inputProps"
        placeholder="Escribe aquí"
      />
    </b-field>

    <!-- Field NUMBER -->
    <b-field
      v-else-if="typeField === 'number'"
      :label="label"
      :message="message"
      :type="statusType"
    >
      <b-input
        v-model.number="localValue"
        type="number"
        v-bind="inputProps"
        placeholder="0"
      />
    </b-field>

    <!-- Field SELECT -->
    <b-field
      v-else-if="typeField === 'select'"
      :label="label"
      :message="message"
      :type="statusType"
    >
      <b-select
        v-model="localValue"
        v-bind="inputProps"
        placeholder="Seleccione una opción"
      >
        <option
          v-for="(opt, idx) in options"
          :key="idx"
          :value="opt.value || opt"
        >
          {{ opt.label || opt }}
        </option>
      </b-select>
    </b-field>

    <p v-else style="color: red">Tipo de campo inválido: {{ typeField }}</p>
  </div>
</template>

<script>
export default {
  name: "DynamicField",
  props: {
    value: {},
    typeField: {
      type: String,
      required: true,
      validator: (v) => ["text", "number", "select"].includes(v),
    },
    label: String,
    options: {
      type: Array,
      default: () => [],
    },
    message: String,
    statusType: String,
    inputProps: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  watch: {
    localValue(val) {
      this.$emit("input", val);
    },
    value(val) {
      this.localValue = val;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/cultura/components/Collaborator/DynamicField.vue